"use strict";
var i18n = require('ofs/i18n');
var gettext = i18n.gettext;

var React = require('react/addons');
var Fluxxor = require('fluxxor');
var FluxMixin = Fluxxor.FluxMixin(React);

var messages = {
  ACCEPT_BUTTON: gettext("I understand"),
  WARNING_HEADER: gettext("Hello. (Thanks for visiting). onefinestay.com is being translated"),
  WARNING_BODY: gettext("While we're translating onefinestay.com into French some parts of the site will be in English only. Something you need to know right away? Talk to our French-speaking reservations team on +44 20 7167 2545. We're here from 8am-10pm GMT.")
};

var SetEnglishLink = React.createClass({
  mixins: [FluxMixin],

  getStateFromFlux: function() {
    return this.getFlux().store('LanguageStore').getState();
  },

  setEnglish: function() {
    this.getFlux().actions.language.setLanguage('en');
    this.getFlux().actions.tracking.sendGenericEvent({
      category: 'setLanguage',
      action: 'en'
    });
  },

  render: function() {
    return (
      <a href="javascript:void(0)" className="ofs-Link" onClick={this.setEnglish}>Show me the site in English</a> // jshint ignore:line
    );
  }
});

var AcceptWarningButton = React.createClass({
  mixins: [FluxMixin],

  getStateFromFlux: function() {
    return this.getFlux().store('LanguageStore').getState();
  },

  acceptWarning: function() {
    this.getFlux().actions.language.acceptLanguageWarning();
  },

  render: function() {
    return (
      <button className="ofs-Button ofs-Button--small" onClick={this.acceptWarning}>{messages.ACCEPT_BUTTON}</button>
    );
  }
});

var WarningMessage = React.createClass({
  mixins: [FluxMixin],

  getStateFromFlux: function() {
    var flux = this.getFlux();
    return flux.store('LanguageStore').getState();
  },

  render: function() {
    return (
      <div className="ofs-LanguageWarning -theme--dark">
        <div className="ofs-Container">
          <div className="ofs-Container__Content">
            <div className="ofs-Row">
              <div className="ofs-LanguageWarning__Message ofs-Row__Column ofs-Row__Column--two-thirds ofs-Row__Column--small-two-thirds">
                <h4>{messages.WARNING_HEADER}</h4>
                <p>{messages.WARNING_BODY}</p>
              </div>
              <div className="ofs-LanguageWarning__Actions ofs-Row__Column ofs-Row__Column--third ofs-Row__Column--small-thirds">
                <AcceptWarningButton />
                <br />
                <SetEnglishLink />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
});

var LanguageWarning = React.createClass({
  mixins: [
    Fluxxor.StoreWatchMixin("LanguageStore"),
    FluxMixin
  ],

  getStateFromFlux: function() {
    var flux = this.getFlux();
    return flux.store('LanguageStore').getState();
  },

  render: function() {
    return (
      this.state.acceptedWarning || this.state.complete ? null : <WarningMessage />
    );
  }
});

module.exports = LanguageWarning;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/react/components/LanguageWarning.jsx
 **/